'use strict';

exports.__esModule = true;

var _loader = require('./loader');

Object.defineProperty(exports, 'Loader', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_loader).default;
  }
});

var _bitmapFontParser = require('./bitmapFontParser');

Object.defineProperty(exports, 'bitmapFontParser', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_bitmapFontParser).default;
  }
});
Object.defineProperty(exports, 'parseBitmapFontData', {
  enumerable: true,
  get: function get() {
    return _bitmapFontParser.parse;
  }
});

var _spritesheetParser = require('./spritesheetParser');

Object.defineProperty(exports, 'spritesheetParser', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_spritesheetParser).default;
  }
});

var _textureParser = require('./textureParser');

Object.defineProperty(exports, 'textureParser', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_textureParser).default;
  }
});

var _resourceLoader = require('resource-loader');

Object.defineProperty(exports, 'Resource', {
  enumerable: true,
  get: function get() {
    return _resourceLoader.Resource;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pixi.js/lib/loaders/index.js
// module id = 754
// module chunks = 1